(function () {
  "use strict";

  class ProductLabelsComponent extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      if (this._product) {
        this.render();
      }
    }

    render() {
      const labels = [];

      // Out of Stock - only show if ALL variants are unavailable
      const hasAvailableVariants = this?._product?.variants?.some(
        (v) => v.availableForSale === true
      );

      if (this?._product?.variants?.length > 0 && !hasAvailableVariants) {
        labels.push(`<span class="product-label product-label--sold-out">SOLD OUT</span>`);
      }

      this.innerHTML = `
        <div class="product-label-container">
          ${labels.slice(0, 2).join("")}
        </div>
        `;
    }
  }

  customElements.define("rcc-product-labels", ProductLabelsComponent);
})();
